<template>
    <div class="md-snapshot-search standard" :style="{ marginBottom }">
        <component
            :is="mdSearchBar"
            :searchBarOnly="true"
            :hideSearch="true"
            ref="search"
            :propsToData="dataToSearchBar"
            @conditionChange="conditionChange"
            v-show="showSearchBar"
        />
        <module-box class="module_box" noPadding noMargin>
            <market-report :title="snapshotMarketTitle" />
        </module-box>
    </div>
</template>

<script>
import MarketReport from './components/market-report/index';
import common from '../index';
import searchBarMixin from '../../md-search-bar-mixin';
export default {
    mixins: [common, searchBarMixin('standard')],
    components: {
        'market-report': MarketReport
    },
    computed: {
        cmpDefaultMoreBtnTitle() {
            return (
                this.defaultMoreBtnTitle ??
                this.$t(
                    'md-snapshot-search.requestMoreMarketInsights'
                ).toUpperCase()
            );
        },
        cmpDefaultListingTitle() {
            return this.$t('md-snapshot-search.recentListings').toUpperCase();
        }
    }
};
</script>
